
 import API from "../../../api";
 import ENDPOINTS from "../../../../config/apiendpoint";
 import constants from "../../../constants";
  
 export default class GetArchiveProjectAPI extends API {
    constructor(projectId, timeout = 2000) {
      super("POST", timeout, false);
      this.type = constants.GET_ARCHIVE_PROJECT;
      this.endpoint = `${super.apiEndPointAuto()}${ENDPOINTS.getProjects}${projectId}/archive/`;    
    }
  
    processResponse(res) {
      super.processResponse(res);
      if (res) {
          this.archiveProject = res;
      }
  }
  
    apiEndPoint() {
      return this.endpoint;
    }
 
    getBody() {}
   
  
    getHeaders() {
      this.headers = {
        headers: {
          "Content-Type": "application/json",
          "Authorization":`JWT ${localStorage.getItem('csi_access_token')}`
        },
      };
      return this.headers;
    }
  
    getPayload() {
      return this.archiveProject;
    }
  }
  